// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./FKGroteskNeueTrial-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "FK Grotesk Neue Trial";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
.TripSummary {
  width: 100%;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
}
.TripSummary .header {
  background-color: #F4F4F4;
  color: #000;
  padding: 25px 20px 25px 20px;
  border: 2px solid #F1F4F9;
}
.TripSummary .header .total-container {
  border: 2px solid #F1F4F9;
  display: flex;
  padding-bottom: 5px;
  align-items: center;
}
.TripSummary .header .total-container .title {
  margin-bottom: 0;
}
.TripSummary .header .total-container .value {
  margin-bottom: 0;
  text-align: end;
  align-self: center;
  margin-left: auto;
  margin-right: 10px;
}
.TripSummary .header .sub-title {
  font-size: 13.5px;
  margin-bottom: 0;
  white-space: nowrap;
}
.TripSummary .header .sub-title svg {
  vertical-align: middle;
}
.TripSummary .header .body-font-p {
  margin-bottom: 0;
  white-space: nowrap;
}
.TripSummary .header .body-font-p svg {
  vertical-align: middle;
}
.TripSummary .header-disabled {
  background-color: #848b94;
}
.TripSummary > .reward-panel {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f1f4f9;
  color: #000;
  border-radius: 24px;
  display: flex;
}
.TripSummary > .reward-panel > .checkbox-panel {
  margin-right: 10px;
}
.TripSummary > .reward-panel > .info-panel > .title {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  margin-bottom: 4px;
}
.TripSummary > .reward-panel > .info-panel > .sub-title {
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #3881ef;
  margin-bottom: 0;
}
.TripSummary .trip-body {
  padding: 0 28px 20px;
  padding-bottom: 20px;
  background-color: white;
  color: #000;
  border: 2px solid #F1F4F9;
}
.TripSummary .trip-body.body-center {
  text-align: center;
}
.TripSummary .trip-body .detail-price-guaranteed {
  display: flex;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-weight: 500;
  margin-top: 24px;
}
.TripSummary .trip-body .detail-price-guaranteed .title {
  margin-bottom: 0;
}
.TripSummary .trip-body .flight-concierge {
  display: flex;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-weight: 500;
  margin-top: 20px;
}
.TripSummary .trip-body .flight-concierge .title {
  margin-bottom: 0;
}
.TripSummary .trip-body .detail-container {
  display: flex;
  font-size: 18px;
  padding-top: 250px;
  padding-bottom: 20px;
  border-bottom: 2px solid rgba(213, 220, 231, 0.3019607843);
  font-weight: 500;
}
.TripSummary .trip-body .detail-container .sub-title {
  font-size: 13px;
  margin-bottom: 0;
}
.TripSummary .trip-body .detail-container .title {
  margin-bottom: 0;
  font-size: 18px;
}
.TripSummary .trip-body .detail-container .value {
  margin-bottom: 15px;
  font-size: 18px;
  text-align: end;
  font-style: normal;
  align-self: center;
  margin-left: auto;
  margin-top: -26px;
}
.TripSummary .trip-body .detail-container .button-container {
  border-bottom: 1px solid #cfcdcd;
}
.TripSummary .trip-body .detail-container-total {
  display: flex;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #cfcdcd;
  font-weight: 500;
}
.TripSummary .trip-body .detail-container-total svg {
  vertical-align: text-bottom;
}
.TripSummary .trip-body .detail-container-total .sub-title {
  font-size: 13px;
  margin-bottom: 0;
}
.TripSummary .trip-body .detail-container-total .title {
  margin-bottom: 0;
  font-size: 12px;
}
.TripSummary .trip-body .detail-container-total .value {
  align-self: center;
  margin-left: auto;
  margin-bottom: 0;
}
.TripSummary .trip-body Button.black-bt {
  background-color: #694779;
}
.TripSummary .trip-body Button.quote-button {
  background-color: #694779;
}
.TripSummary .trip-body .TripPriceContainer {
  flex-direction: column;
  padding: 25px 0px 9px 0px;
}
.TripSummary .trip-body .TripPriceContainer div {
  margin-bottom: 7px;
}
@media screen and (max-width: 767px) {
  .TripSummary .trip-body .quote-succ .quote-succ-tick {
    width: 65.33px !important;
    height: 65.33px !important;
    padding: 4% 0 !important;
  }
  .TripSummary .trip-body .quote-succ .qoute-succ-img {
    width: 35px;
    height: 35px;
  }
}
.TripSummary .trip-body .quote-succ .quote-succ-tick {
  text-align: center;
  background-color: #694779;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  padding: 7% 0;
  margin: 35px auto 25px auto;
}
.TripSummary .trip-body .quote-succ .quote-succ-msg {
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  display: block;
  text-align: center;
  /* Black / 100 */
  color: #000000;
}
.TripSummary .subtitile-h5,
.TripSummary .subtitile-h4 {
  margin-bottom: 0px;
  font-size: 22px;
}

.top-title {
  font-size: 12px;
  margin-left: 3px;
}

.info-text-recommended {
  color: #848b94;
  width: 85%;
  text-align: center;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 0px !important;
}

.fuel-msg {
  margin-right: 5px;
  vertical-align: middle !important;
}

.fuel-msg-div {
  margin-top: 10px;
  text-align: center;
  align-items: center;
}

.help-title {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  align-items: center;
  text-align: center;
  color: #000000;
  margin-top: 5px;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .help-title {
    font-weight: 600;
  }
  ::i-block-chrome,
  .help-title {
    font-weight: 400;
  }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
  .TripSummary .header {
    padding: 8px;
  }
  .TripSummary .subtitile-h5,
  .TripSummary .subtitile-h4 {
    font-size: 14px !important;
  }
  .TripSummary .trip-body {
    padding: 0 10px;
  }
  .TripSummary .trip-body .detail-container .value {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) and (max-width: 850px) {
  .TripSummary .subtitile-h5,
  .TripSummary .subtitile-h4 {
    font-size: 23px !important;
  }
  .TripSummary .trip-body .detail-container .title {
    margin-bottom: 0;
    font-size: 14px;
  }
  .TripSummary .trip-body .detail-container .value {
    font-size: 15px;
  }
}
@media screen and (min-width: 768px) and (max-width: 820px) {
  .help-title {
    font-size: 12px !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .TripSummary .trip-body .quote-succ .quote-succ-tick {
    padding: 3% 0;
  }
}
@media screen and (min-width: 1200px) {
  .help-title {
    white-space: nowrap;
  }
  .details-container {
    width: 382px !important;
  }
}
.ruler-mid-width {
  width: 100%;
  margin-top: 10px;
  border-top: 2px solid rgba(213, 220, 231, 0.3019607843) !important;
}

.help-title-font-style {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  align-items: center;
  text-align: center;
  color: #000000;
  margin-top: 30px;
  letter-spacing: 0.6px;
}

.help-title-sub-font-style {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  align-items: center;
  text-align: center;
  color: #000000;
  margin-bottom: 20px;
  font-family: FK Grotesk Neue Trial;
}

.talk-to-concierge-button-style {
  margin-right: 19px;
  margin-left: -20px;
  height: 25px;
  margin-top: -3px !important;
}

.trip-price-sub-div {
  padding: 0px 5px 0px 5px;
}

.trip-summary-body-padding {
  padding-bottom: 33px !important;
}

.trip-estimate-title {
  font-size: 24px !important;
}

@media screen and (max-width: 767px) {
  .trip-summary-box-shadow-hidden {
    box-shadow: none;
  }
  .TripSummary .trip-body .detail-container .value {
    margin-bottom: 4px;
  }
}
@media screen and (max-width: 435px) {
  .talk-to-concierge-button-style {
    margin-right: 8px;
    margin-left: 6px;
  }
  .TripSummary .header .total-container {
    border: 2px solid #f1f4f9;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0px;
    gap: 14px;
  }
}
.help-title {
  font-weight: 600;
  font-size: 17px !important;
}

@media screen and (max-width: 767px) {
  .mobile-only-down-arrow {
    display: inline-block !important;
  }
  .ruler-mid-width {
    width: 95%;
  }
  .TripSummary .header {
    padding: 10px 18px 10px 18px;
  }
  .TripSummary .header .total-container {
    border: 2px solid #f1f4f9;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0px;
    gap: 14px;
  }
  .mobile-only-down-arrow {
    display: inline-block !important;
  }
  .TripSummary .header .total-container .value {
    margin-right: 0px !important;
  }
  .TripSummary .header {
    padding: 10px 10px 10px 10px;
  }
  .trip-body {
    transition: max-height 0.3s ease-in-out;
    overflow: hidden;
    position: absolute;
    right: 16px;
    left: 16px;
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
    overflow: hidden;
    z-index: 1;
    box-shadow: 0px 10px 20px -1px rgba(0, 0, 0, 0.15);
  }
  .body-hidden {
    max-height: 0;
    opacity: 0;
    visibility: hidden;
  }
  .body-visible {
    max-height: 1000px;
    opacity: 1;
    visibility: visible;
  }
  .mobile-only-down-arrow {
    cursor: pointer;
  }
  .TripSummary .trip-body {
    padding: 0px 10px 20px 10px;
  }
  .request-trip-btn-padding {
    padding: 0px 7px 0px 7px;
  }
}
.mobile-only-down-arrow {
  display: none;
}

@media screen and (max-width: 387px) {
  .trip-estimate-title {
    font-size: 17px !important;
  }
  .TripSummary .subtitile-h4 {
    font-size: 17px;
  }
}
@media screen and (min-width: 387px) and (max-width: 767px) {
  .trip-estimate-title {
    font-size: 20px !important;
  }
  .TripSummary .subtitile-h4 {
    font-size: 18px;
  }
}
.custom-tooltip {
  pointer-events: none;
}

.custom-tooltip .tooltip-inner {
  background-color: #000;
  color: #fff;
  font-size: 12px;
  padding: 10px;
  border-radius: 12px;
  margin-left: -230px;
  max-width: 300px;
  top: -4px;
  position: relative;
  font-family: FK Grotesk Neue Trial;
}

.custom-tooltip .tooltip-arrow::before {
  border-width: 9px !important;
  left: -4px !important;
  top: -4px !important;
}

.info-icon {
  margin-top: -2px;
  cursor: pointer;
}

.trip-warn-text {
  font-size: 12px;
  font-family: FK Grotesk Neue Trial;
  text-align: center;
}

.request-trip {
  display: flex !important;
  justify-content: center !important;
}

.quote-succ-tick-background {
  background-color: unset !important;
}

.trip-estimate-title-center {
  font-size: 24px !important;
  font-weight: bold !important;
}

.help-title-font-weight {
  font-weight: bold !important;
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/TripSummary/TripSummary.scss","webpack://./src/containers/ChooseAFlight/themevariable.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAIA;EACE,WAAA;EAGA,6CAAA;AAFF;AAIE;EACE,yBCZ0B;EDa1B,WAAA;EACA,4BAAA;EACA,yBAAA;AAFJ;AAGI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AADN;AAEM;EACE,gBAAA;AAAR;AAGM;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AADR;AAKI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAIM;EACE,sBAAA;AAFR;AAKI;EACE,gBAAA;EACA,mBAAA;AAHN;AAIM;EACE,sBAAA;AAFR;AAOE;EACE,yBE7CI;AFwCR;AAQE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBEtDI;EFuDJ,WE9DI;EF+DJ,mBAAA;EACA,aAAA;AANJ;AAQI;EACE,kBAAA;AANN;AAUM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AARR;AAWM;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cE/ED;EFgFC,gBAAA;AATR;AAcE;EAEE,oBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WE7FI;EF8FJ,yBAAA;AAbJ;AAeI;EACE,kBAAA;AAbN;AAgBI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EAEA,gBAAA;EACA,gBAAA;AAfN;AAiBM;EACE,gBAAA;AAfR;AAmBI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EAEA,gBAAA;EACA,gBAAA;AAlBN;AAoBM;EACE,gBAAA;AAlBR;AAsBI;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,0DAAA;EACA,gBAAA;AApBN;AAsBM;EACE,eAAA;EACA,gBAAA;AApBR;AAuBM;EACE,gBAAA;EACA,eAAA;AArBR;AAwBM;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAtBR;AAwBM;EACE,gCAAA;AAtBR;AAyBI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,gBAAA;AAvBN;AAyBM;EACE,2BAAA;AAvBR;AA0BM;EACE,eAAA;EACA,gBAAA;AAxBR;AA2BM;EACE,gBAAA;EACA,eAAA;AAzBR;AA4BM;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AA1BR;AA6BI;EACE,yBAAA;AA3BN;AA6BI;EACE,yBAAA;AA3BN;AA8BI;EACE,sBAAA;EACA,yBAAA;AA5BN;AA6BM;EACE,kBAAA;AA3BR;AA8BI;EAEI;IACE,yBAAA;IACA,0BAAA;IACA,wBAAA;EA7BR;EA+BM;IACE,WAAA;IACA,YAAA;EA7BR;AACF;AAiCM;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AA/BR;AAiCM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAGA,kBAAA;EAEA,gBAAA;EAEA,cAAA;AAnCR;AA0CE;;EAEE,kBAAA;EACA,eAAA;AAxCJ;;AA2CA;EACE,eAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,cEtPM;EFuPN,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;AAxCF;;AA2CA;EACE,iBAAA;EACA,iCAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAxCF;;AA0CA;EAEE;IACE,gBAAA;EAxCF;EA4CA;;IAEE,gBAAA;EA1CF;AACF;AA4CA;EAEI;IACE,YAAA;EA3CJ;EA6CE;;IAEE,0BAAA;EA3CJ;EA6CE;IACE,eAAA;EA3CJ;EA4CI;IACE,eAAA;EA1CN;AACF;AA8CA;EACE;;IAEE,0BAAA;EA5CF;EA8CA;IACE,gBAAA;IACA,eAAA;EA5CF;EA8CA;IACE,eAAA;EA5CF;AACF;AA8CA;EACE;IACE,0BAAA;EA5CF;AACF;AA8CA;EACE;IACE,aAAA;EA5CF;AACF;AA8CA;EACE;IACE,mBAAA;EA5CF;EA8CA;IACE,uBAAA;EA5CF;AACF;AA8CA;EACE,WAAA;EACA,gBAAA;EACA,kEAAA;AA5CF;;AA8CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AA3CF;;AA6CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EAEA,mBAAA;EACA,kCAAA;AA3CF;;AA6CA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;AA1CF;;AA4CA;EACE,wBAAA;AAzCF;;AA2CA;EACE,+BAAA;AAxCF;;AA0CA;EACE,0BAAA;AAvCF;;AAyCA;EACE;IACE,gBAAA;EAtCF;EAwCA;IACE,kBAAA;EAtCF;AACF;AAwCA;EACE;IACE,iBAAA;IACA,gBAAA;EAtCF;EAwCA;IACE,yBAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,mBAAA;IACA,SAAA;EAtCF;AACF;AAwCA;EACE,gBAAA;EACA,0BAAA;AAtCF;;AAyCA;EACE;IACE,gCAAA;EAtCF;EAwCA;IACE,UAAA;EAtCF;EAwCA;IACE,4BAAA;EAtCF;EAwCA;IACE,yBAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,mBAAA;IACA,SAAA;EAtCF;EAwCA;IACE,gCAAA;EAtCF;EAwCA;IACE,4BAAA;EAtCF;EAwCA;IACE,4BAAA;EAtCF;EAwCA;IACE,uCAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;IACA,iEAAA;IACA,gBAAA;IACA,UAAA;IAIA,kDAAA;EAvCF;EAyCA;IACE,aAAA;IACA,UAAA;IACA,kBAAA;EAvCF;EA0CA;IACE,kBAAA;IACA,UAAA;IACA,mBAAA;EAxCF;EA2CA;IACE,eAAA;EAzCF;EA2CA;IACE,2BAAA;EAzCF;EA2CA;IACE,wBAAA;EAzCF;AACF;AA2CA;EACE,aAAA;AAzCF;;AA2CA;EACE;IACE,0BAAA;EAxCF;EA0CA;IACE,eAAA;EAxCF;AACF;AA0CA;EACE;IACE,0BAAA;EAxCF;EA0CA;IACE,eAAA;EAxCF;AACF;AA0CA;EACE,oBAAA;AAxCF;;AA0CA;EACE,sBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,kCAAA;AAvCF;;AA0CA;EACE,4BAAA;EACA,qBAAA;EACA,oBAAA;AAvCF;;AAyCA;EACE,gBAAA;EACA,eAAA;AAtCF;;AAwCA;EACE,eAAA;EACA,kCAAA;EACA,kBAAA;AArCF;;AAuCA;EACE,wBAAA;EACA,kCAAA;AApCF;;AAsCA;EACE,kCAAA;AAnCF;;AAqCA;EACE,0BAAA;EACA,4BAAA;AAlCF;;AAoCA;EACE,4BAAA;AAjCF","sourcesContent":["@use \"src/styles/variables\" as var;\n@use \"src/containers/ChooseAFlight/themevariable.scss\" as theme;\n\n@font-face {\n  font-family: \"FK Grotesk Neue Trial\";\n  src: url(\"./FKGroteskNeueTrial-Regular.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n.TripSummary {\n  width: 100%;\n  -webkit-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n  -moz-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n  box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n\n  .header {\n    background-color: theme.$searchPanelBackgroundColor;\n    color: #000;\n    padding: 25px 20px 25px 20px;\n    border: 2px solid theme.$customSecondaryColor;\n    .total-container {\n      border: 2px solid theme.$customSecondaryColor;\n      display: flex;\n      padding-bottom: 5px;\n      align-items: center;\n      .title {\n        margin-bottom: 0;\n      }\n\n      .value {\n        margin-bottom: 0;\n        text-align: end;\n        align-self: center;\n        margin-left: auto;\n        margin-right: 10px;\n      }\n    }\n\n    .sub-title {\n      font-size: 13.5px;\n      margin-bottom: 0;\n      white-space: nowrap;\n      svg {\n        vertical-align: middle;\n      }\n    }\n    .body-font-p {\n      margin-bottom: 0;\n      white-space: nowrap;\n      svg {\n        vertical-align: middle;\n      }\n    }\n  }\n\n  .header-disabled {\n    background-color: var.$grey3;\n  }\n\n  > .reward-panel {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 20px;\n    background-color: var.$grey1;\n    color: var.$black;\n    border-radius: 24px;\n    display: flex;\n\n    > .checkbox-panel {\n      margin-right: 10px;\n    }\n\n    > .info-panel {\n      > .title {\n        font-weight: 600;\n        font-size: 18px;\n        line-height: 23px;\n        margin-bottom: 4px;\n      }\n\n      > .sub-title {\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 18px;\n        color: var.$blue;\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .trip-body {\n    // padding: 0 33px 20px;\n    padding: 0 28px 20px;\n    padding-bottom: 20px;\n    background-color: #ffff;\n    color: var.$black;\n    border: 2px solid theme.$customSecondaryColor;\n\n    &.body-center {\n      text-align: center;\n    }\n\n    .detail-price-guaranteed {\n      display: flex;\n      font-size: 16px;\n      padding-top: 20px;\n      padding-bottom: 20px;\n      //   border-top: 1px solid $grey2;\n      font-weight: 500;\n      margin-top: 24px;\n\n      .title {\n        margin-bottom: 0;\n      }\n    }\n\n    .flight-concierge {\n      display: flex;\n      font-size: 16px;\n      padding-top: 20px;\n      padding-bottom: 20px;\n      // border-top: 1px solid $grey2;\n      font-weight: 500;\n      margin-top: 20px;\n\n      .title {\n        margin-bottom: 0;\n      }\n    }\n\n    .detail-container {\n      display: flex;\n      font-size: 18px;\n      padding-top: 250px;\n      padding-bottom: 20px;\n      border-bottom: 2px solid #d5dce74d;\n      font-weight: 500;\n\n      .sub-title {\n        font-size: 13px;\n        margin-bottom: 0;\n      }\n\n      .title {\n        margin-bottom: 0;\n        font-size: 18px;\n      }\n\n      .value {\n        margin-bottom: 15px;\n        font-size: 18px;\n        text-align: end;\n        font-style: normal;\n        align-self: center;\n        margin-left: auto;\n        margin-top: -26px;\n      }\n      .button-container {\n        border-bottom: 1px solid var.$grey2;\n      }\n    }\n    .detail-container-total {\n      display: flex;\n      font-size: 16px;\n      padding-top: 20px;\n      padding-bottom: 20px;\n      border-bottom: 1px solid var.$grey2;\n      font-weight: 500;\n\n      svg {\n        vertical-align: text-bottom;\n      }\n\n      .sub-title {\n        font-size: 13px;\n        margin-bottom: 0;\n      }\n\n      .title {\n        margin-bottom: 0;\n        font-size: 12px;\n      }\n\n      .value {\n        align-self: center;\n        margin-left: auto;\n        margin-bottom: 0;\n      }\n    }\n    Button.black-bt {\n      background-color: #694779;\n    }\n    Button.quote-button {\n      background-color: #694779;\n    }\n\n    .TripPriceContainer {\n      flex-direction: column;\n      padding: 25px 0px 9px 0px;\n      div {\n        margin-bottom: 7px;\n      }\n    }\n    @media screen and (max-width: 767px) {\n      .quote-succ {\n        .quote-succ-tick {\n          width: 65.33px !important;\n          height: 65.33px !important;\n          padding: 4% 0 !important;\n        }\n        .qoute-succ-img {\n          width: 35px;\n          height: 35px;\n        }\n      }\n    }\n    .quote-succ {\n      .quote-succ-tick {\n        text-align: center;\n        background-color: #694779;\n        border-radius: 50%;\n        width: 80px;\n        height: 80px;\n        padding: 7% 0;\n        margin: 35px auto 25px auto;\n      }\n      .quote-succ-msg {\n        font-style: normal;\n        font-weight: 600;\n        font-size: 30px;\n        line-height: 38px;\n        display: block;\n        // display: flex;\n        // align-items: center;\n        text-align: center;\n\n        /* Black / 100 */\n\n        color: #000000;\n\n        //  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      }\n    }\n  }\n\n  .subtitile-h5,\n  .subtitile-h4 {\n    margin-bottom: 0px;\n    font-size: 22px; // 18px;\n  }\n}\n.top-title {\n  font-size: 12px;\n  margin-left: 3px;\n}\n\n.info-text-recommended {\n  color: var.$grey3;\n  width: 85%;\n  text-align: center;\n  margin: auto;\n  padding-top: 30px;\n  padding-bottom: 0px !important;\n}\n\n.fuel-msg {\n  margin-right: 5px;\n  vertical-align: middle !important;\n}\n\n.fuel-msg-div {\n  margin-top: 10px;\n  text-align: center;\n  align-items: center;\n}\n\n.help-title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 26px;\n  align-items: center;\n  text-align: center;\n  color: #000000;\n  margin-top: 5px;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  // / Safari and Chrome /\n  .help-title {\n    font-weight: 600;\n  }\n\n  // / Safari only override /\n  ::i-block-chrome,\n  .help-title {\n    font-weight: 400;\n  }\n}\n@media screen and (var.$tablet-media-min-hz) and (var.$tablet-media-hz) {\n  .TripSummary {\n    .header {\n      padding: 8px;\n    }\n    .subtitile-h5,\n    .subtitile-h4 {\n      font-size: 14px !important;\n    }\n    .trip-body {\n      padding: 0 10px;\n      .detail-container .value {\n        font-size: 16px;\n      }\n    }\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 850px) {\n  .TripSummary .subtitile-h5,\n  .TripSummary .subtitile-h4 {\n    font-size: 23px !important;\n  }\n  .TripSummary .trip-body .detail-container .title {\n    margin-bottom: 0;\n    font-size: 14px;\n  }\n  .TripSummary .trip-body .detail-container .value {\n    font-size: 15px;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 820px) {\n  .help-title {\n    font-size: 12px !important;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .TripSummary .trip-body .quote-succ .quote-succ-tick {\n    padding: 3% 0;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .help-title {\n    white-space: nowrap;\n  }\n  .details-container {\n    width: 382px !important;\n  }\n}\n.ruler-mid-width {\n  width: 100%;\n  margin-top: 10px;\n  border-top: 2px solid #d5dce74d !important;\n}\n.help-title-font-style {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  align-items: center;\n  text-align: center;\n  color: #000000;\n  margin-top: 30px;\n  letter-spacing: 0.6px;\n}\n.help-title-sub-font-style {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 26px;\n  align-items: center;\n  text-align: center;\n  color: #000000;\n  // margin-top: -15px;\n  margin-bottom: 20px;\n  font-family: FK Grotesk Neue Trial;\n}\n.talk-to-concierge-button-style {\n  margin-right: 19px;\n  margin-left: -20px;\n  height: 25px;\n  margin-top: -3px !important;\n}\n.trip-price-sub-div {\n  padding: 0px 5px 0px 5px;\n}\n.trip-summary-body-padding {\n  padding-bottom: 33px !important;\n}\n.trip-estimate-title {\n  font-size: 24px !important;\n}\n@media screen and (max-width: 767px) {\n  .trip-summary-box-shadow-hidden {\n    box-shadow: none;\n  }\n  .TripSummary .trip-body .detail-container .value {\n    margin-bottom: 4px;\n  }\n}\n@media screen and (max-width: 435px) {\n  .talk-to-concierge-button-style {\n    margin-right: 8px;\n    margin-left: 6px;\n  }\n  .TripSummary .header .total-container {\n    border: 2px solid #f1f4f9;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 0px;\n    gap: 14px;\n  }\n}\n.help-title {\n  font-weight: 600;\n  font-size: 17px !important;\n}\n//Trip summary mob screen change\n@media screen and (max-width: 767px) {\n  .mobile-only-down-arrow {\n    display: inline-block !important;\n  }\n  .ruler-mid-width {\n    width: 95%;\n  }\n  .TripSummary .header {\n    padding: 10px 18px 10px 18px;\n  }\n  .TripSummary .header .total-container {\n    border: 2px solid #f1f4f9;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 0px;\n    gap: 14px;\n  }\n  .mobile-only-down-arrow {\n    display: inline-block !important;\n  }\n  .TripSummary .header .total-container .value {\n    margin-right: 0px !important ;\n  }\n  .TripSummary .header {\n    padding: 10px 10px 10px 10px;\n  }\n  .trip-body {\n    transition: max-height 0.3s ease-in-out;\n    overflow: hidden;\n    position: absolute;\n    right: 16px;\n    left: 16px;\n    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n    overflow: hidden;\n    z-index: 1;\n    -webkit-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    -moz-box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    // box-shadow: (0px 10px 20px rgba(0, 0, 0, 0.15));\n    box-shadow: (0px 10px 20px -1px rgba(0, 0, 0, 0.15));\n  }\n  .body-hidden {\n    max-height: 0;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  .body-visible {\n    max-height: 1000px; // Adjust this as needed\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .mobile-only-down-arrow {\n    cursor: pointer;\n  }\n  .TripSummary .trip-body {\n    padding: 0px 10px 20px 10px;\n  }\n  .request-trip-btn-padding {\n    padding: 0px 7px 0px 7px;\n  }\n}\n.mobile-only-down-arrow {\n  display: none;\n}\n@media screen and (max-width: 387px) {\n  .trip-estimate-title {\n    font-size: 17px !important;\n  }\n  .TripSummary .subtitile-h4 {\n    font-size: 17px;\n  }\n}\n@media screen and (min-width: 387px) and (max-width: 767px) {\n  .trip-estimate-title {\n    font-size: 20px !important;\n  }\n  .TripSummary .subtitile-h4 {\n    font-size: 18px;\n  }\n}\n.custom-tooltip {\n  pointer-events: none;\n}\n.custom-tooltip .tooltip-inner {\n  background-color: #000;\n  color: #fff;\n  font-size: 12px;\n  padding: 10px;\n  border-radius: 12px;\n  margin-left: -230px;\n  max-width: 300px;\n  top: -4px;\n  position: relative;\n  font-family: FK Grotesk Neue Trial;\n}\n\n.custom-tooltip .tooltip-arrow::before {\n  border-width: 9px !important;\n  left: -4px !important;\n  top: -4px !important;\n}\n.info-icon {\n  margin-top: -2px;\n  cursor: pointer;\n}\n.trip-warn-text {\n  font-size: 12px;\n  font-family: FK Grotesk Neue Trial;\n  text-align: center;\n}\n.request-trip {\n  display: flex !important;\n  justify-content: center !important;\n}\n.quote-succ-tick-background {\n  background-color: unset !important;\n}\n.trip-estimate-title-center {\n  font-size: 24px !important;\n  font-weight: bold !important;\n}\n.help-title-font-weight {\n  font-weight: bold !important;\n}\n","$defaultBackgroundColor : #FFFFFF;\n$defaultFontColor : #000000;\n$customPrimaryColor : #694779;\n$customFontColor : #FFFFFF;\n$searchPanelBackgroundColor : #F4F4F4;\n$descriptionFontColor : #2C3034;\n$customSecondaryColor : #F1F4F9;\n$listItemFeatureFontColor : #535A61;\n$conciergeButtonBackgroundColor : #B9A691;","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
